import Refluxr from '../../lib/refluxr';
import { OnlineApi } from '../services';
let container = require('../core/container');

function IssueActions() {
   const Actions = Refluxr.createActions(
      [
         'setIssueFiltersSync',
         'beginFetchIssuesSync',
         'beginRaiseIssueSync',
         'resetRaiseIssueSync',
         'beginGetIssueSync',
         'beginGetIssueTimelineSync',
         'beginGetIssueNotesSync',
         'setIssueNoteDraftSync',
         'beginAddIssueCommentSync',
         'beginDeleteIssueCommentSync',
         'resetDeleteIssueCommentSync',
         'beginAssignIssueSync',
         'beginManageIssueTagsSync',
         'beginCreateIssueTagSync',
         'beginCloseIssueSync',
         'beginReopenIssueSync',
         'beginEditIssueDefinitionSync',
         'beginResetIssueDeadlineSync',
         'resetIssueDefinitionSync',
         'resetIssueDeadlineSync',
         'resetIssueLifecycleSync',
         'removeIssueOptimisticMessageSync',
         'resetIssueDetailSync',
         'resetIssuesSync',
         {
            raiseIssue: OnlineApi.send,
            prepare: function ({ idIssue, title, description, noLocation, zonedFor, tagNames, noPriority, dueBy, who, utcNow }) {
               return {
                  messageType: 'RAISE_ISSUE',
                  idIssue,
                  title,
                  description,
                  noLocation,
                  zonedFor,
                  tagNames,
                  noPriority,
                  dueBy,
                  who,
                  utcNow
               };
            }
         },
         {
            getIssueNotes: OnlineApi.send,
            prepare: function ({ idChannel }) {
               return {
                  messageType: 'GET_CHANNEL',
                  idChannel
               };
            }
         },
         {
            addIssueComment: OnlineApi.send,
            prepare: function ({ idIssue, noIssue, idChannel, idFrame, comment, meta = {} }) {
               return {
                  messageType: 'ADD_ISSUE_COMMENT',
                  idIssue,
                  noIssue,
                  idChannel,
                  idFrame,
                  comment,
                  meta
               };
            }
         },
         {
            deleteIssueComment: OnlineApi.send,
            prepare: function ({ idIssue, noIssue, idChannel, idFrame, utcNow }) {
               return {
                  messageType: 'DELETE_ISSUE_COMMENT',
                  idIssue,
                  noIssue,
                  idChannel,
                  idFrame,
                  utcNow
               };
            }
         },
         {
            assignIssue: OnlineApi.send,
            prepare: function ({ idIssue, noIssue, who }) {
               return {
                  messageType: 'ASSIGN_ISSUE',
                  idIssue,
                  noIssue,
                  who
               };
            }
         },
         {
            manageIssueTags: OnlineApi.send,
            prepare: function ({ idIssue, noIssue, selectedTags, availableTags }) {
               return {
                  messageType: 'MANAGE_ISSUE_TAGS',
                  idIssue,
                  noIssue,
                  selectedTags,
                  availableTags
               };
            }
         },
         {
            createIssueTag: OnlineApi.send,
            prepare: function ({ idIssue, noIssue, name }) {
               return {
                  messageType: 'TAG_ISSUES',
                  idsIssue: idIssue ? [idIssue] : [],
                  nosIssue: noIssue != null ? [noIssue] : [],
                  name
               };
            }
         },
         {
            closeIssue: OnlineApi.send,
            prepare: function ({ idIssue, noIssue, utcNow }) {
               return {
                  messageType: 'CLOSE_ISSUE',
                  idIssue,
                  noIssue,
                  utcNow,
                  isResolved: true
               };
            }
         },
         {
            reopenIssue: OnlineApi.send,
            prepare: function ({ idIssue, noIssue, utcNow }) {
               return {
                  messageType: 'REOPEN_ISSUE',
                  idIssue,
                  noIssue,
                  utcNow
               };
            }
         },
         {
            updateIssueDefinition: OnlineApi.send,
            prepare: function ({ idIssue, noIssue, title, description, noPriority, utcNow }) {
               return {
                  messageType: 'UPDATE_ISSUE',
                  idIssue,
                  noIssue,
                  updateSections: ['define'],
                  title,
                  description,
                  noPriority,
                  utcNow
               };
            }
         },
         {
            resetIssueDeadline: OnlineApi.send,
            prepare: function ({ idIssue, noIssue, utcNow }) {
               return {
                  messageType: 'UPDATE_ISSUE',
                  idIssue,
                  noIssue,
                  updateSections: ['resetWhenToPriority'],
                  utcNow
               };
            }
         },
         {
            getIssueTimeline: OnlineApi.send,
            prepare: function ({ noIssue, limit = 20 }) {
               return {
                  messageType: 'GET_ISSUE_TIMELINE',
                  noIssue,
                  limit
               };
            }
         },
         {
            getIssue: OnlineApi.send,
            prepare: function ({ noIssue }) {
               return {
                  messageType: 'GET_ISSUE',
                  noIssue
               };
            }
         },
         {
            fetchIssues: OnlineApi.send,
            prepare: function (args) {
               return {
                  messageType: 'FETCH_ISSUES',
                  idIssueViewType: args.idIssueViewType,
                  idIssueSortType: args.idIssueSortType == null ? null : args.idIssueSortType,
                  searchText: args.searchText || '',
                  nosLocation: args.nosLocation || [],
                  nosPosition: [],
                  nosTeam: [],
                  nosStaff: [],
                  forMe: false,
                  limit: args.limit,
                  page: args.page,
                  withTags: [],
                  withoutTags: [],
                  filters: args.filters || []
               };
            }
         }
      ],
      container.getGlobalHandler(),
      container.getFeedbackHandler()
   );

   return Actions;
}

IssueActions.instance = new IssueActions();


export default IssueActions.instance;
